<template>
  <div class="main">
    <share-modal v-if="isBrowser" ref="shareModal"></share-modal>

    <div
      class="container-fluid"
      data-spy="scroll"
      data-target="#menuScrollspy"
      data-offset="90"
    >
      <div id="menuScrollspy">
        <ul class="nav nav-tabs menu hidden-xs" role="tablist">
          <li>
            <a href="#intro"></a>
          </li>
          <li>
            <a href="#development"></a>
          </li>
          <li>
            <a href="#product"></a>
          </li>
          <li>
            <a href="#map"></a>
          </li>
        </ul>
        <ul class="content" ref="itemList" id="listgroup">
          <li class="list_li">
            <header-box ref="header"></header-box>
          </li>
          <li class="list_li">
            <about-banner></about-banner>
          </li>
          <li id="intro" class="list_li">
            <div class="container">
              <h1 class="title"><span class="left-divider"></span> 企业简介</h1>
              <div class="company-profile">
                <img
                  class="img-responsive visible-xs"
                  src="../../assets/images/about_us_mobile.png"
                  alt=""
                />
                <div>
                  <div class="txt">
                    厦门搜谷信息科技有限公司成立于2009年，公司始终秉承“移动改变生活”的经营理念，一直致力于“移动物联、智慧交通”领域的应用及平台的开发与运营，努力打造“绿色出行、低碳环保”的移动互联新型业务。公司拥有一支涉及通信、计算机、金融、市场营销等专业的核心团队，具有丰富的IT及重大项目的经营管理和资本运作经验。主要发起人及核心成员均具有硕士以上学历，是一支年轻的、朝气蓬勃同时又具有丰富经验的队伍。
                  </div>
                  <div class="txt">
                    2009 年，开创了国内最早的实时公交
                    APP——掌上公交，是国内领先的实时公交出行 APP
                    开发、运营企业，在实时交通大数据领域具备多年研究与实践经验，拥有强大的数据分析系统和专业的数据维护团队，对于智慧城市建设，特别是在智能交通领域有着深厚积淀。掌上公交产品已在全国覆盖400多个城市，累计服务超过
                    2亿用户，开创了智能公交新模式。
                  </div>
                </div>
                <img
                  class="img-responsive hidden-xs"
                  src="../../assets/images/about_us.png"
                  alt=""
                />
              </div>
            </div>
          </li>
          <li id="development" class="list_li">
            <div class="container">
              <h1 class="title"><span class="left-divider"></span>发展历程</h1>
              <h1 class="sub_title">
                <div id="triangle-down"></div>
                <span class="hidden-xs">发展历程——搜谷大事记</span>
              </h1>
              <ul class="line-container">
                <li
                  class="line-item"
                  v-for="(item, index) in lineList"
                  :key="index"
                >
                  <div class="item-tag">{{ item.time }}</div>
                  <div class="item-symbol">
                    <div class="item-circle"></div>
                    <!---->
                  </div>
                  <div class="item-txt">{{ item.txt }}</div>
                </li>
              </ul>
            </div>
          </li>
          <li id="product" class="list_li">
            <div class="container">
              <h1 class="title">
                <span class="left-divider"></span>
                产品介绍
              </h1>
              <div>
                <div class="media">
                  <div class="hidden-xs media-left">
                    <img src="@/assets/images/icon_logo.png" />
                  </div>
                  <div class="media-body">
                    <div class="mobile-title visible-xs">
                      <img src="@/assets/images/icon_logo.png" />
                      <span>掌上公交</span>
                    </div>
                    <div class="media-content">
                      <div>
                        <span class="sub_title"
                          >掌上公交 （又名:掌上出行）</span
                        >
                        <span
                          >是国内最早发布的一款实时公交智能查询软件，支持公交路线、站点实时查询和线路换乘规划功能，并提供了包括定制公交、网约拼巴、企业专线、扫码乘车和包车租车在内的多款个性化出行服务。作为一个城市公共交通出行服务平台，掌上公交还支持城市公共交通公告发布、失物招领服务以及公共出行实名登记服务。</span
                        >
                      </div>
                      <p>
                        除了面向广大市民乘客提供服务，掌上公交凭借多年在智能交通领域的研究和实践经验，也面向合作城市的交通部门提供了多元化的公交大数据解决方案，持续帮助交通业务服务部门提升了工作效益。
                      </p>
                      <p>
                        掌上公交目前已覆盖全国400多个城市，累计服务超过2亿用户，在十年的发展历程中曾多次被央视和地方卫视报道，是各城市“互联网+公交”智慧城市项目的重要合作伙伴。
                      </p>

                      <div class="visible-xs down-btn">
                        <button class="mobile-btn" @click="downZsgj">
                          下载APP体验
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="media">
                  <div class="hidden-xs media-left">
                    <img src="@/assets/images/wgj-logo.png" />
                  </div>
                  <div class="media-body">
                    <div class="mobile-title visible-xs">
                      <img src="@/assets/images/wgj-logo.png" />
                      <span>微公交</span>
                    </div>
                    <div class="media-content">
                      <span class="sub_title">微循环响应式公交（微公交）</span>
                      <span>
                        采用定站不定线的运营模式，包含即时约车，预约叫，代叫模式，根据乘客个人出行需求动态匹配线路，实现“动态需求”、“动态发车”、“动态线路”；结合移动互联网+公交出行模式，形成具有线上资源合理分配，线下高效优质运行的新业态，微公交线路由于其线路短，班次灵活，即叫即停，多元化的运营模式，呈现出较强的运营活动力和服务至上的亲和力，有效解决乘客出现“开始一公里”和“最后一公里”的城市公共交通运行方式。
                        <!-- <a
                          href="http://lytaohuitao.com/"
                          target="_blank"
                          class="hidden-xs"
                        >查看详情 >></a>-->
                      </span>
                      <!-- <div class="visible-xs down-btn">
                        <button class="mobile-btn" @click="downZsgj">
                          下载APP体验
                        </button>
                      </div> -->
                      <!-- <p>
                        <a href="http://m.mygolbs.com/download/">下载链接：http://m.mygolbs.com/download/</a>
                      </p>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li id="map" class="list_li">
            <div class="container">
              <h1 class="title">
                <span class="left-divider"></span>
                联系我们
              </h1>
              <div class="map_info">
                <ul class="map_txt">
                  <li>
                    <span>交通数据/商务合作：</span>
                    <a href="mailto:bd@mygolbs.com">bd@mygolbs.com</a>
                  </li>
                  <li>
                    <span>人事招聘：</span>
                    <a href="mailto:hr@mygolbs.com">hr@mygolbs.com</a>
                  </li>
                  <li>
                    <span>广告合作：</span>
                    <a href="mailto:ad@mygolbs.com">ad@mygolbs.com</a>
                  </li>
                  <li>
                    <span>联系电话：</span>
                    <a href="tel:0592-5128197">0592-5128197</a>
                  </li>
                  <li>
                    <span
                      >公司地址：福建省厦门市思明区宜兰路99号海峡明珠广场6F</span
                    >
                  </li>
                </ul>

                <div class="amap-wrapper">
                  <el-amap
                    class="amap-box"
                    :vid="'amap-vue'"
                    :center="center"
                    :zoom="14"
                    :zoomEnable="false"
                  >
                    <el-amap-marker
                      vid="component-marker"
                      :position="componentMarker.position"
                      icon
                      :content="imgUrl"
                      style
                    ></el-amap-marker>
                  </el-amap>
                </div>
              </div>
            </div>
          </li>
          <li class="list_li">
            <footer-box ref="footer"></footer-box>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import AboutBanner from "components/banner/about.banner";
import FooterBox from "components/footer/footer";
import HeaderBox from "components/header/header";
import ShareModal from "components/sharemodal/sharemodal";

// import $ from "jquery";
export default {
  data() {
    return {
      lineList: [
        {
          time: "2009年03月",
          txt: "搜谷科技注册成立"
        },
        {
          time: "2010年06月",
          txt: "掌上公交客户端上线"
        },
        {
          time: "2011年03月",
          txt: "掌上公交推出公交动态线路规划功能"
        },
        {
          time: "2014年03月",
          txt: "掌上公交 覆盖全国 60 多个城市，累计用户超过1千万"
        },
        {
          time: "2015年06月",
          txt: "掌上公交推出“定制公交”、“NFC 公交电子站牌”等服务"
        },
        {
          time: "2016年06月",
          txt: "掌上公交升级动态线路规划功能"
        },
        {
          time: "2017年10月",
          txt: "掌上公交覆盖全国200多个城市，累计用户超过 5千万"
        },
        {
          time: "2018年03月",
          txt: "掌上公交微信小程序上线"
        },
        {
          time: "2019年04月",
          txt: "掌上公交改版，以“移动改变生活”理念推出更多便民服务"
        },
        {
          time: "2019年12月",
          txt: "掌上公交覆盖全国300多个城市，累计用户超过1个亿"
        },
        {
          time: "2020年01月",
          txt: "掌上公交参与建设国家交通运输部科技示范工程"
        },
        {
          time: "2020年03月",
          txt: "掌上公交支付宝小程序上线"
        },
        {
          time: "2020年07月",
          txt: "掌上公交百度小程序、今日头条小程序、QQ小程序上线"
        },
        {
          time: "2021年06月",
          txt: "掌上公交覆盖全国400多个城市，累计用户超过2个亿"
        },
        {
          time: "2022年06月",
          txt: "微循环响应式公交（微公交）上线"
        }
      ],
      isBrowser: true,
      center: [118.195682, 24.495351],
      componentMarker: {
        position: [118.195682, 24.495351]
      },
      imgUrl: `<img style='width:20px;' src= ${require("../../assets/images/location.png")}>`,
      curConfig: {}
    };
  },
  components: {
    HeaderBox,
    FooterBox,
    AboutBanner,
    ShareModal
  },

  methods: {
    // jumpAppStore() {
    //   if (this.curConfig.isQQ) {
    //     this.isBrowser = true;
    //     this.$refs.shareModal.toogleShow();
    //   } else {
    //     window.open(
    //       `https://apps.apple.com/cn/app/%E6%8E%8C%E4%B8%8A%E5%85%AC%E4%BA%A4-%E7%B2%BE%E5%87%86%E5%AE%9E%E6%97%B6%E5%85%AC%E4%BA%A4%E5%9C%B0%E9%93%81%E6%9F%A5%E8%AF%A2/id461317017`
    //     );
    //   }
    // },
    // jumpAndroid() {
    //   // this.isBrowser = true;
    //   // this.$refs.shareModal.toogleShow();
    //   if (this.curConfig.isWeiXin || this.curConfig.isQQ) {
    //     this.isBrowser = true;
    //     this.$refs.shareModal.toogleShow();
    //   } else {
    //     window.open(`http://m.mygolbs.com/dl/MyBus.apk`);
    //   }
    // },
    downZsgj() {
      if (this.curConfig.isIOS) {
        this.$refs.footer.jumpAppStore();
      } else if (this.curConfig.isAndroid) {
        this.$refs.footer.jumpAndroid();
      } else if (this.curConfig.isHarmonyOS) {
        this.$refs.footer.jumpHarmonyOS();
      }
    },
    downTht() {
      if (this.curConfig.isIOS) {
        window.open(
          `https://apps.apple.com/cn/app/%E6%B7%98%E6%83%A0%E6%B7%98-%E8%BF%94%E5%88%A9%E6%90%9C%E5%88%B8%E7%9C%81%E9%92%B1-app/id1484656371`
        );
      } else {
        if (this.curConfig.isWeiXin || this.curConfig.isQQ) {
          this.isBrowser = true;
          this.$refs.shareModal.toogleShow();
        } else window.open(`https://static.lytaohuitao.com/app/tht.apk`);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
    });
    this.curConfig = this.$browser();
    $(".container-fluid").scrollspy({
      target: "#menuScrollspy"
    });
  }
};
</script>

<style lang="less" scoped>
@import "./aboutus.less";
</style>



// WEBPACK FOOTER //
// src/components/aboutus/aboutus.vue